<template>
  <goods-detail></goods-detail>
</template>

<script>
import GoodsDetail from "@/components/shop/goods/goodsDetail";
export default {
  name: "goods_detail",
  components: {GoodsDetail}
}
</script>

<style scoped>

</style>